import { ParameterContext } from '@contexts/parameters'
import { useContext } from 'react'

export const useParameter = (name: string) => useContext(ParameterContext)[name]
